const blank = {
	"refresh": 0,
	"comments": {
		"show": false,
		"content": ""
	},
	"flightTimer": {
		"clock": "",
		"clockUTC": "",
		"elapsed": "0.0 Hours"
	},
	"logbook": {
		"timeOut": "------------",
		"timeIn": "------------"
	},
	"preferences": {
		"defaultViewMode": "horz",
		"speedType": "KIAS"
	},
	"selected": {
		"listIndex": 0,
		"sectionIndex": 0,
		"itemIndex": 0
	},
	"selectedListIndex": 0,
	"type": "checklist",
	"checklistView": "horz",
	"speakMode": "check",
	"id": "",
	"name": "",
	"description": "",
	"genre": "misc",
	"publisher": "self",
	"tags": [],
	"speedType": "KIAS",
	"children": [],
	"version": "1.0",
	"revision": 1,
	"revisionTs": new Date().getTime()
};

const templateChecklist = {
	"refresh": 0, "comments": { "show": false, "content": "" }, "flightTimer": { "clock": "", "clockUTC": "", "elapsed": "0.0 Hours" }, "logbook": { "timeOut": "------------", "timeIn": "------------" }, "preferences": { "defaultViewMode": "horz", "speedType": "KIAS" }, "selected": { "listIndex": 0, "sectionIndex": 0, "itemIndex": 0 }, "selectedListIndex": 0, "type": "checklist", "checklistView": "horz", "speakMode": "check", "id": "bafceb6d-3152-4b81-a017-685c3638c4eb", "name": "Procedure: Checklist", "description": "", "genre": "misc", "publisher": "self", "tags": [], "speedType": "KIAS", "children": [{ "id": "", "guid": "35fa1b1a-1d6b-4528-a5c1-222f967f746d", "groupNames": [], "filterTags": [], "type": "list", "completionState": "n", "ignoreCompletion": false, "name": "List 1", "nameAlexaPlain": "", "nameAlexaRich": "", "nameAudio": "", "nameSsml": "", "namePrint": "", "defaultView": "checklistView", "styles": {}, "classes": {}, "color": "", "iconColor": "", "backgroundColor": "", "borderColor": "", "suppressPrint": false, "horzScrollPos": 0, "vertScrollPos": 0, "children": [{ "id": "", "guid": "1aba287d-662b-4d99-9e4a-e78dab23abcc", "groupNames": [], "filterTags": [], "type": "section", "completionState": "n", "ignoreCompletion": false, "name": "Section 1", "nameAlexaPlain": "", "nameAlexaRich": "", "nameAudio": "", "nameSsml": "", "namePrint": "", "styles": {}, "classes": {}, "color": "", "backgroundColor": "", "borderColor": "", "iconColor": "", "suppressPrint": false, "vertScrollPos": 0, "children": [{ "id": "", "guid": "f705ea32-d8e5-4f22-a2a4-c8d450f3c97a", "groupNames": [], "filterTags": [], "type": "item", "checked": false, "ignoreCompletion": false, "backgroundColor": "", "label1": "Check item 1", "label1AlexaPlain": "", "label1AlexaRich": "", "label1Audio": "", "label1Ssml": "", "label1Print": "", "styles": {}, "classes": {}, "color": "", "label2": "", "label2AlexaPlain": "", "label2AlexaRich": "", "label2Audio": "", "label2Ssml": "", "label2Print": "", "label2Color": "", "mandatory": false, "comments": "", "commentsInline": false, "commentsAuthor": "", "commentsAudio": "", "commentsSsml": "", "commentsPrint": "", "commentsTemplate": "", "commentsDataPath": "", "linkOnCheck": false, "linkId": "", "linkActionType": "goto", "valueTrigger": "", "backgroundImage": "", "video": "", "image": "", "audio": "", "pdf": "", "itemButtonOkLabel": "", "itemButtonBackLabel": "", "itemButtonOkVisibility": "inherit", "itemButtonBackVisibility": "inherit", "fullscreenActionNavOrder": "inherit", "fullscreenActionToolBackgroundColor": "", "fullscreenActionToolForegroundColor": "", "itemAttachmentsLabel": "", "itemCommentsIcon": "", "itemRelatedItemsIcon": "", "itemAttachmentsIcon": "", "suppressPrint": false, "startTracking": false, "stopTracking": false, "saveOnCheck": false, "saveAndExitOnCheck": false, "generateReportOnCheck": false, "generateReportOnCheckTemplate": "", "startNamedTimers": [], "stopNamedTimers": [], "useAsSessionName": false, "isSearchable": false, "enabled": true, "visible": true, "conditionalVisible": "", "calculatedDefaultValue": "", "labelOnly": false, "labelOnlyBackgroundColor": "", "startTimer": false, "stopTimer": false }, { "id": "", "guid": "dd373a69-bcc7-40dd-afcc-a3ea5af204ee", "groupNames": [], "filterTags": [], "type": "item", "checked": false, "ignoreCompletion": false, "backgroundColor": "", "label1": "Check item 2", "label1AlexaPlain": "", "label1AlexaRich": "", "label1Audio": "", "label1Ssml": "", "label1Print": "", "styles": {}, "classes": {}, "color": "", "label2": "", "label2AlexaPlain": "", "label2AlexaRich": "", "label2Audio": "", "label2Ssml": "", "label2Print": "", "label2Color": "", "mandatory": false, "comments": "", "commentsInline": false, "commentsAuthor": "", "commentsAudio": "", "commentsSsml": "", "commentsPrint": "", "commentsTemplate": "", "commentsDataPath": "", "linkOnCheck": false, "linkId": "", "linkActionType": "goto", "valueTrigger": "", "backgroundImage": "", "video": "", "image": "", "audio": "", "pdf": "", "itemButtonOkLabel": "", "itemButtonBackLabel": "", "itemButtonOkVisibility": "inherit", "itemButtonBackVisibility": "inherit", "fullscreenActionNavOrder": "inherit", "fullscreenActionToolBackgroundColor": "", "fullscreenActionToolForegroundColor": "", "itemAttachmentsLabel": "", "itemCommentsIcon": "", "itemRelatedItemsIcon": "", "itemAttachmentsIcon": "", "suppressPrint": false, "startTracking": false, "stopTracking": false, "saveOnCheck": false, "saveAndExitOnCheck": false, "generateReportOnCheck": false, "generateReportOnCheckTemplate": "", "startNamedTimers": [], "stopNamedTimers": [], "useAsSessionName": false, "isSearchable": false, "enabled": true, "visible": true, "conditionalVisible": "", "calculatedDefaultValue": "", "labelOnly": false, "labelOnlyBackgroundColor": "", "startTimer": false, "stopTimer": false }, { "id": "", "guid": "be5f0b18-fa17-414e-956b-6017dd616c9c", "groupNames": [], "filterTags": [], "type": "item", "checked": false, "ignoreCompletion": false, "backgroundColor": "", "label1": "Check item 3", "label1AlexaPlain": "", "label1AlexaRich": "", "label1Audio": "", "label1Ssml": "", "label1Print": "", "styles": {}, "classes": {}, "color": "", "label2": "", "label2AlexaPlain": "", "label2AlexaRich": "", "label2Audio": "", "label2Ssml": "", "label2Print": "", "label2Color": "", "mandatory": false, "comments": "", "commentsInline": false, "commentsAuthor": "", "commentsAudio": "", "commentsSsml": "", "commentsPrint": "", "commentsTemplate": "", "commentsDataPath": "", "linkOnCheck": false, "linkId": "", "linkActionType": "goto", "valueTrigger": "", "backgroundImage": "", "video": "", "image": "", "audio": "", "pdf": "", "itemButtonOkLabel": "", "itemButtonBackLabel": "", "itemButtonOkVisibility": "inherit", "itemButtonBackVisibility": "inherit", "fullscreenActionNavOrder": "inherit", "fullscreenActionToolBackgroundColor": "", "fullscreenActionToolForegroundColor": "", "itemAttachmentsLabel": "", "itemCommentsIcon": "", "itemRelatedItemsIcon": "", "itemAttachmentsIcon": "", "suppressPrint": false, "startTracking": false, "stopTracking": false, "saveOnCheck": false, "saveAndExitOnCheck": false, "generateReportOnCheck": false, "generateReportOnCheckTemplate": "", "startNamedTimers": [], "stopNamedTimers": [], "useAsSessionName": false, "isSearchable": false, "enabled": true, "visible": true, "conditionalVisible": "", "calculatedDefaultValue": "", "labelOnly": false, "labelOnlyBackgroundColor": "", "startTimer": false, "stopTimer": false }], "enabled": true, "visible": true }], "enabled": true, "visible": true }, { "id": "", "guid": "6ad19427-9b82-45ae-9c5f-3f8bf3e0a730", "groupNames": [], "filterTags": [], "type": "list", "completionState": "n", "ignoreCompletion": false, "name": "List 2", "nameAlexaPlain": "", "nameAlexaRich": "", "nameAudio": "", "nameSsml": "", "namePrint": "", "defaultView": "checklistView", "styles": {}, "classes": {}, "color": "", "iconColor": "", "backgroundColor": "", "borderColor": "", "suppressPrint": false, "horzScrollPos": 0, "vertScrollPos": 0, "children": [{ "id": "", "guid": "bbc65fb4-c427-40a3-98fe-6c1f32b4bc34", "groupNames": [], "filterTags": [], "type": "section", "completionState": "n", "ignoreCompletion": false, "name": "Section 1", "nameAlexaPlain": "", "nameAlexaRich": "", "nameAudio": "", "nameSsml": "", "namePrint": "", "styles": {}, "classes": {}, "color": "", "backgroundColor": "", "borderColor": "", "iconColor": "", "suppressPrint": false, "vertScrollPos": 0, "children": [{ "id": "", "guid": "9cb4744f-7496-4694-8efe-fb0f50cb025a", "groupNames": [], "filterTags": [], "type": "item", "checked": false, "ignoreCompletion": false, "backgroundColor": "", "label1": "Check item 1", "label1AlexaPlain": "", "label1AlexaRich": "", "label1Audio": "", "label1Ssml": "", "label1Print": "", "styles": {}, "classes": {}, "color": "", "label2": "", "label2AlexaPlain": "", "label2AlexaRich": "", "label2Audio": "", "label2Ssml": "", "label2Print": "", "label2Color": "", "mandatory": false, "comments": "", "commentsInline": false, "commentsAuthor": "", "commentsAudio": "", "commentsSsml": "", "commentsPrint": "", "commentsTemplate": "", "commentsDataPath": "", "linkOnCheck": false, "linkId": "", "linkActionType": "goto", "backgroundImage": "", "video": "", "image": "", "audio": "", "pdf": "", "suppressPrint": false, "startTracking": false, "stopTracking": false, "saveOnCheck": false, "saveAndExitOnCheck": false, "generateReportOnCheck": false, "generateReportOnCheckTemplate": "", "enabled": true, "visible": true, "labelOnly": false, "labelOnlyBackgroundColor": "", "startTimer": false, "stopTimer": false }, { "id": "", "guid": "6d9a2bad-163b-48d6-9ffd-c14bc44f885d", "groupNames": [], "filterTags": [], "type": "item", "checked": false, "ignoreCompletion": false, "backgroundColor": "", "label1": "Check item 2", "label1AlexaPlain": "", "label1AlexaRich": "", "label1Audio": "", "label1Ssml": "", "label1Print": "", "styles": {}, "classes": {}, "color": "", "label2": "", "label2AlexaPlain": "", "label2AlexaRich": "", "label2Audio": "", "label2Ssml": "", "label2Print": "", "label2Color": "", "mandatory": false, "comments": "", "commentsInline": false, "commentsAuthor": "", "commentsAudio": "", "commentsSsml": "", "commentsPrint": "", "commentsTemplate": "", "commentsDataPath": "", "linkOnCheck": false, "linkId": "", "linkActionType": "goto", "backgroundImage": "", "video": "", "image": "", "audio": "", "pdf": "", "suppressPrint": false, "startTracking": false, "stopTracking": false, "saveOnCheck": false, "saveAndExitOnCheck": false, "generateReportOnCheck": false, "generateReportOnCheckTemplate": "", "enabled": true, "visible": true, "labelOnly": false, "labelOnlyBackgroundColor": "", "startTimer": false, "stopTimer": false }, { "id": "", "guid": "49bb7e64-de80-4973-857e-b05c6aca4d59", "groupNames": [], "filterTags": [], "type": "item", "checked": false, "ignoreCompletion": false, "backgroundColor": "", "label1": "Check item 3", "label1AlexaPlain": "", "label1AlexaRich": "", "label1Audio": "", "label1Ssml": "", "label1Print": "", "styles": {}, "classes": {}, "color": "", "label2": "", "label2AlexaPlain": "", "label2AlexaRich": "", "label2Audio": "", "label2Ssml": "", "label2Print": "", "label2Color": "", "mandatory": false, "comments": "", "commentsInline": false, "commentsAuthor": "", "commentsAudio": "", "commentsSsml": "", "commentsPrint": "", "commentsTemplate": "", "commentsDataPath": "", "linkOnCheck": false, "linkId": "", "linkActionType": "goto", "backgroundImage": "", "video": "", "image": "", "audio": "", "pdf": "", "suppressPrint": false, "startTracking": false, "stopTracking": false, "saveOnCheck": false, "saveAndExitOnCheck": false, "generateReportOnCheck": false, "generateReportOnCheckTemplate": "", "enabled": true, "visible": true, "labelOnly": false, "labelOnlyBackgroundColor": "", "startTimer": false, "stopTimer": false }], "enabled": true, "visible": true }], "enabled": true, "visible": true }], "revision": 1, "revisionTs": new Date().getTime(), "guid": "11bf67e4-94c8-4c4c-92ff-ce6d7ef85738", "baseIds": [], "checklistId": "", "nameAlexaPlain": "", "nameAlexaRich": "", "nameAudio": "", "nameSsml": "", "namePrint": "", "contributors": [{ "name": "Org Admin", "username": "scheckeh", "nickname": "" }], "cloned": false, "authorProperties": {}, "theme": {}, "styles": {}, "classes": {}, "stylesheet": {}, "backgroundImage": "", "video": "", "image": "", "audio": "", "pdf": "", "heroImage": "", "driveRootPath": "procedure-checklist", "startInShowMode": false, "allowSwitchToShowMode": false, "suppressAudio": false, "trackLocation": false, "uploadAndOptimizeMediaFile": false, "dataSources": [], "externalResources": [], "suppressPrint": false, "itemButtonOkLabel": "OK ✓", "itemButtonBackLabel": "Back ↑", "itemButtonOkVisibility": "visible", "itemButtonBackVisibility": "hidden", "fullscreenActionVariant": "standard", "fullscreenActionPlacement": "overlay", "fullscreenActionFlowWhenScrollable": false, "fullscreenActionNavAlignment": "left", "fullscreenActionNavOrder": "primary-first", "fullscreenActionStyle": "emphasized", "fullscreenActionPrimaryColor": "#2f6df6", "fullscreenActionSurfaceColor": "rgba(31,35,47,0.88)", "fullscreenActionToolBackgroundColor": "", "fullscreenActionToolForegroundColor": "", "itemCommentsLabel": "More Info", "itemRelatedItemsLabel": "Related", "itemAttachmentsLabel": "", "itemCommentsIcon": "info-circle", "itemRelatedItemsIcon": "chart-network", "itemAttachmentsIcon": "paperclip", "itemCommentsBackgroundColor": "", "itemCommentsForegroundColor": "", "itemRelatedItemsBackgroundColor": "", "itemRelatedItemsForegroundColor": "", "itemAttachmentsBackgroundColor": "", "itemAttachmentsForegroundColor": "", "submitLabel": "Save + Exit", "lockOnSubmit": false, "submitLabelWhenComplete": "Save + Exit", "lockOnSubmitWhenComplete": false, "functions": "", "contentModel": ""
};

const templateForm = {
	"refresh": 0,
	"comments": {
		"show": false,
		"content": ""
	},
	"flightTimer": {
		"clock": "",
		"clockUTC": "",
		"elapsed": "0.0 Hours"
	},
	"logbook": {
		"timeOut": "------------",
		"timeIn": "------------"
	},
	"preferences": {
		"defaultViewMode": "horz",
		"speedType": "KIAS"
	},
	"selected": {
		"listIndex": 0,
		"sectionIndex": 0,
		"itemIndex": 0
	},
	"selectedListIndex": 0,
	"type": "checklist",
	"checklistView": "horz",
	"speakMode": "check",
	"id": "",
	"name": "",
	"description": "",
	"genre": "misc",
	"publisher": "self",
	"tags": [],
	"speedType": "KIAS",
	"children": [],
	"version": "1.0",
	"revision": 1,
	"revisionTs": new Date().getTime()
};
const templateThemed = {
	"refresh": 0,
	"comments": {
		"show": false,
		"content": ""
	},
	"flightTimer": {
		"clock": "",
		"clockUTC": "",
		"elapsed": "0.0 Hours"
	},
	"logbook": {
		"timeOut": "------------",
		"timeIn": "------------"
	},
	"preferences": {
		"defaultViewMode": "horz",
		"speedType": "KIAS"
	},
	"selected": {
		"listIndex": 0,
		"sectionIndex": 0,
		"itemIndex": 0
	},
	"selectedListIndex": 0,
	"type": "checklist",
	"checklistView": "horz",
	"speakMode": "check",
	"id": "",
	"name": "",
	"description": "",
	"genre": "misc",
	"publisher": "self",
	"tags": [],
	"speedType": "KIAS",
	"children": [],
	"version": "1.0",
	"revision": 1,
	"revisionTs": new Date().getTime()
};
const showmodeBlank = {
	"refresh": 0,
	"comments": {
		"show": false,
		"content": ""
	},
	"flightTimer": {
		"clock": "",
		"clockUTC": "",
		"elapsed": "0.0 Hours"
	},
	"logbook": {
		"timeOut": "------------",
		"timeIn": "------------"
	},
	"preferences": {
		"defaultViewMode": "horz",
		"speedType": "KIAS"
	},
	"selected": {
		"listIndex": 0,
		"sectionIndex": 0,
		"itemIndex": 0
	},
	"selectedListIndex": 0,
	"type": "checklist",
	"checklistView": "horz",
	"speakMode": "check",
	"id": "",
	"name": "",
	"description": "",
	"genre": "misc",
	"publisher": "self",
	"tags": [],
	"speedType": "KIAS",
	"children": [],
	"version": "1.0",
	"revision": 1,
	"revisionTs": new Date().getTime()
};
const showmodePrefilled = {
	"refresh": 0,
	"comments": {
		"show": false,
		"content": ""
	},
	"flightTimer": {
		"clock": "",
		"clockUTC": "",
		"elapsed": "0.0 Hours"
	},
	"logbook": {
		"timeOut": "------------",
		"timeIn": "------------"
	},
	"preferences": {
		"defaultViewMode": "horz",
		"speedType": "KIAS"
	},
	"selected": {
		"listIndex": 0,
		"sectionIndex": 0,
		"itemIndex": 0
	},
	"selectedListIndex": 0,
	"type": "checklist",
	"checklistView": "horz",
	"speakMode": "check",
	"id": "",
	"name": "",
	"description": "",
	"genre": "misc",
	"publisher": "self",
	"tags": [],
	"speedType": "KIAS",
	"children": [],
	"version": "1.0",
	"revision": 1,
	"revisionTs": new Date().getTime()
};
const definitions = [
	{
		id: "blank",
		title: "Procedure: Blank",
		description: "Start from scratch with a brand new procedure",
		icon: "./assets/templatePreview/template-blank.svg",
		template: blank
	},
	{
		id: "templateChecklist",
		title: "Procedure: Checklist",
		description: "A basic checklist template.",
		icon: "./assets/templatePreview/template-checklist.svg",
		template: templateChecklist,
		subSelect: [{
			title: "Flat",
			id: "flat",
			description: "Just Check Items",
			icon: "./assets/templatePreview/flat.svg",
			template: templateChecklist
		}, {
			title: "Single Layer",
			description: "Check Items in Sections",
			id: "singleLayer",
			icon: "./assets/templatePreview/sections.svg",
			template: templateChecklist
		}, {
			title: "Two Layers",
			description: "Check Items in Sections and Lists",
			default: true,
			id: "twoLayers",
			icon: "./assets/templatePreview/lists.svg",
			template: templateChecklist
		}]
	},
	{
		id: "templateForm",
		title: "Procedure: Form",
		description: "A basic form template.",
		icon: "./assets/templatePreview/template-form.svg",
		template: templateForm,
		subSelect: [{
			title: "Flat",
			id: "flat",
			description: "Just Check Items",
			icon: "./assets/templatePreview/flat.svg",
			template: templateChecklist
		}, {
			title: "Single Layer",
			description: "Check Items in Sections",
			id: "singleLayer",
			icon: "./assets/templatePreview/sections.svg",
			template: templateChecklist
		}, {
			title: "Two Layers",
			description: "Check Items in Sections and Lists",
			default: true,
			id: "twoLayers",
			icon: "./assets/templatePreview/lists.svg",
			template: templateChecklist
		}]
	},
	{
		id: "templateThemed",
		title: "Procedure: Form + Basic Theming",
		description: "A basic form template including some basic theming.",
		icon: "./assets/templatePreview/template-themed.svg",
		template: templateThemed,
		subSelect: [{
			title: "Flat",
			id: "flat",
			description: "Just Check Items",
			icon: "./assets/templatePreview/flat.svg",
			template: templateChecklist
		}, {
			title: "Single Layer",
			description: "Check Items in Sections",
			id: "singleLayer",
			icon: "./assets/templatePreview/sections.svg",
			template: templateChecklist
		}, {
			title: "Two Layers",
			description: "Check Items in Sections and Lists",
			default: true,
			id: "twoLayers",
			icon: "./assets/templatePreview/lists.svg",
			template: templateChecklist
		}]
	},
	{
		id: "showmodeBlank",
		title: "Show Mode: Blank",
		description: "Start from scratch show mode template.",
		icon: "./assets/templatePreview/showmode-blank.svg",
		template: showmodeBlank
	},
	{
		id: "showmodePrefilled",
		title: "Show Mode: Simple",
		description: "A show mode template with a few slides.",
		icon: "./assets/templatePreview/showmode-prefilled.svg",
		template: showmodePrefilled
	}
];

export default {
	template: {
		blank,
		templateChecklist,
		templateForm,
		templateThemed,
		showmodeBlank,
		showmodePrefilled
	},
	definitions
};
